<template>
  <div class="sort">
    <sort-result-sort-select
      :orderText="selectedOrderText"
      :isVisibleOrderSelectBox="order"
      :isVisibleChoiceSelectBox="choices"
      @clickedOrder="toggleVisibleOrder"
      @cliedChoices="toggleVisibleSort"
    />
    <sort-result-sort-order
      v-show="order"
      :list="conditions.order"
      @clickedSort="selectedChoice2"
    />
    <sort-result-sort-choices
      v-show="choices"
      :brandList="conditions.brand"
      :skincareList="conditions.skincare"
      :baseList="conditions.base"
      :selectList1="conditions.select1"
      :selectList2="conditions.select2"
      :selectList3="conditions.select3"
      :selectList4="conditions.select4"
      @clickedSort="selectedChoice"
      @sortChoices="sortChoices2"
    />
  </div>
</template>

<script>
import SortResultSortChoices from './SortResultSortChoices.vue'
import SortResultSortOrder from './SortResultSortOrder.vue'
import SortResultSortSelect from './SortResultSortSelect.vue'
export default {
  components: { SortResultSortSelect, SortResultSortOrder, SortResultSortChoices },
  name: 'SortResultSort',
  props: {
    conditions: {
      type: Object
    }
  },
  data: () => {
    return {
      order: false,
      choices: false,
      isSwitchOrder: false,
      isSwitchChoices: false
    };
  },
  computed: {
    selectedOrderText() {
      const _selectedIndex = this.conditions.order.findIndex(item => item.selected === true);
      return this.conditions.order[_selectedIndex].text;
    }
  },
  methods: {
    /**
     * 並べ替えボタンが押された時
     */
    toggleVisibleOrder() {
      this.choices ? this.isSwitchChoices = true : this.isSwitchChoices = false;
      this.order = !this.order;
      this.choices = false;
      setTimeout(() => {
        this.$emit('updateSortHeight');
      }, 100);
    },
    /**
     * 絞り込みボタンが押された時
     */
    toggleVisibleSort() {
      this.order ? this.isSwitchOrder = true : this.isSwitchOrder = false;
      this.choices = !this.choices;
      this.order = false;
      setTimeout(() => {
        this.$emit('updateSortHeight');
      }, 100);
    },
    /**
     * 条件を絞り込む
     * @param index {Number} 選択した要素の配列の中の順番
     * @param type {String} 選択した要素が存在する配列
     */
    selectedChoice(index, type) {
      if (type === 'order') this.order = false;
      // this.$emit('selectedChoices', index, type);
    },
    /**
     * 条件を絞り込む2
     * @param index {Number} 選択した要素の配列の中の順番
     * @param type {String} 選択した要素が存在する配列
     */
    selectedChoice2(index, type) {
      if (type === 'order') this.order = false;

      this.$emit('selectedChoices', index, type);
      // init
      this.$emit('searchReview');
    },
    /**
     * 全ての選択状態を解除する
     */
    hide() {
      this.order = false;
      this.choices = false;
      this.isSwitchOrder = false;
      this.isSwitchChoices = false;
    },
    /**
     * 条件で絞り込む再建策
     */
    // sortReviews() {
    //   this.$emit('sortReviews');
    // },
    // sortChoices(status) {
    //   this.$emit('sortChoices', status);
    // },
    /**
     * 条件で絞り込む再建策
     */
    sortChoices2() {
      this.$emit('searchReview');
      this.choices = false;
    }
  }
}
</script>
